import { useState, useCallback } from 'react'
import { X } from 'lucide-react'
import {
  ModalOverlay,
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalDescription,
  TextArea,
  ModalFooter,
  CharacterCount,
  Spacer,
  ModalButton,
  ContentWrapper,
  InputSection,
  DescriptionWrapper,
  InputFooter,
  DEFAULT_SAVE_BUTTON_COLOR,
  DEFAULT_CANCEL_BUTTON_COLOR,
  InputTitle
} from './styles'

const GenericModal = ({
  isOpen,
  onClose,
  title,
  description,
  inputTitle,
  onSave,
  saveButtonText = 'Guardar',
  cancelButtonText = 'Cancelar',
  placeholder = 'Describe brevemente el motivo...',
  maxLength = 250,
  withInput = true,
  saveButtonColor,
  cancelButtonColor,
  showCancelButton = true
}) => {
  const [value, setValue] = useState('')

  const handleSave = useCallback(() => {
    if (withInput && !value.trim()) {
      return
    }
    onSave(value)
    setValue('')
    onClose()
  }, [withInput, value, onSave, onClose])

  const finalSaveButtonColor = saveButtonColor || DEFAULT_SAVE_BUTTON_COLOR
  const finalCancelButtonColor = cancelButtonColor || DEFAULT_CANCEL_BUTTON_COLOR

  if (!isOpen) return null

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <ModalContainer>
        <ModalContent>
          <ContentWrapper>
            <Header title={title} onClose={onClose} />

            <Body
              description={description}
              withInput={withInput}
              value={value}
              setValue={setValue}
              placeholder={placeholder}
              maxLength={maxLength}
              inputTitle={inputTitle}
            />

            <Footer
              cancelButtonText={cancelButtonText}
              saveButtonText={saveButtonText}
              finalCancelButtonColor={finalCancelButtonColor}
              finalSaveButtonColor={finalSaveButtonColor}
              onClose={onClose}
              handleSave={handleSave}
              withInput={withInput}
              value={value}
              showCancelButton={showCancelButton}
            />

          </ContentWrapper>
        </ModalContent>
      </ModalContainer>
    </>
  )
}

const Header = ({ title, onClose }) => (
  <ModalHeader compact={title.length < 100}>
    <Spacer />
    <ModalTitle large={title.length < 30}>{title}</ModalTitle>
    <CloseButton onClick={onClose}>
      <X size={20} />
    </CloseButton>
  </ModalHeader>
)

const Body = ({ description, withInput, value, setValue, placeholder, maxLength, inputTitle }) => (
  <DescriptionWrapper>
    <ModalDescription>{description}</ModalDescription>
    {withInput && (
      <InputSection>
        <InputTitle>{inputTitle}</InputTitle>
        <TextArea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          maxLength={maxLength}
        />
        <InputFooter>
          <CharacterCount>
            {value.length}/{maxLength}
          </CharacterCount>
        </InputFooter>
      </InputSection>
    )}
  </DescriptionWrapper>
)

const Footer = ({ cancelButtonText, saveButtonText, finalCancelButtonColor, finalSaveButtonColor, onClose, handleSave, withInput, value, showCancelButton }) => (
  <ModalFooter>
    {showCancelButton && (
      <ModalButton color={finalCancelButtonColor} onClick={onClose}>
        {cancelButtonText}
      </ModalButton>
    )}
    <ModalButton
      color={finalSaveButtonColor}
      disabled={withInput && !value.trim()}
      onClick={() => {
        if (!withInput || value.trim()) {
          handleSave()
        }
      }}
    >
      {saveButtonText}
    </ModalButton>
  </ModalFooter>
)

export default GenericModal
